const ETHNICITY_NATIONALITY = {
	Caucasian: 'American',
	African: 'American',
	Asian: 'Japanese',
	Arab: 'Egyptian',
	Hispanic: 'Spanish',
	'Middle Eastern': 'Turkish',
	Mixed: 'British',
	'Native American': 'American',
	'Pacific Islander': 'Australian',
	'South Asian': 'Indian',
};

export const NATIONALITY_CITY_SUGGESTIONS = {
	American: ['New York', 'Los Angeles', 'Chicago', 'Miami', 'San Francisco'],
	British: ['London', 'Manchester', 'Birmingham', 'Edinburgh', 'Glasgow'],
	Polish: ['Warsaw', 'Kraków', 'Wrocław', 'Gdańsk', 'Poznań'],
	French: ['Paris', 'Marseille', 'Lyon', 'Nice', 'Bordeaux'],
	Spanish: ['Madrid', 'Barcelona', 'Valencia', 'Seville', 'Bilbao'],
	Italian: ['Rome', 'Milan', 'Naples', 'Florence', 'Venice'],
	German: ['Berlin', 'Munich', 'Hamburg', 'Frankfurt', 'Cologne'],
	Ukrainian: ['Kyiv', 'Lviv', 'Odesa', 'Kharkiv', 'Dnipro'],
	Brazilian: ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza'],
	Mexican: ['Mexico City', 'Guadalajara', 'Monterrey', 'Cancún', 'Puebla'],
	Japanese: ['Tokyo', 'Osaka', 'Kyoto', 'Yokohama', 'Nagoya'],
	Korean: ['Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon'],
	Chinese: ['Shanghai', 'Beijing', 'Guangzhou', 'Shenzhen', 'Chengdu'],
	Indian: ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai'],
	Egyptian: ['Cairo', 'Alexandria', 'Giza', 'Luxor', 'Aswan'],
	Turkish: ['Istanbul', 'Ankara', 'Izmir', 'Antalya', 'Bursa'],
	Australian: ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide'],
	Canadian: ['Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Ottawa'],
};

export const pickRandomCity = (nationality) => {
	const cities = NATIONALITY_CITY_SUGGESTIONS[nationality];

	if (!cities?.length) {
		return 'New York';
	}

	return cities[Math.floor(Math.random() * cities.length)];
};

export const suggestLocationFromEthnicity = (ethnicity) => {
	const nationality = ETHNICITY_NATIONALITY[ethnicity] ?? 'American';

	return {
		nationality,
		city: pickRandomCity(nationality),
	};
};
